import { render, staticRenderFns } from "./ImpactCalculationMethod.vue?vue&type=template&id=68d6b1f5&"
import script from "./ImpactCalculationMethod.vue?vue&type=script&lang=js&"
export * from "./ImpactCalculationMethod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports